if (typeof ModalsComponent !== 'function') {
	class ModalsComponent extends HTMLElement {
		constructor() {
			super();

			this.showAfter = this.dataset.show ? this.dataset.show * 1000 : 0;
			this.ref = this.dataset.ref ?? null;

			this.selectors = {
				close: '[data-modal-close]',
				newsletterAcceptBtn: '[data-newsletter-accept]',
				customAcceptBtn: '[data-custom-accept]',
				emailInput: '[data-email-input]',
			};

			this.close = this.querySelector(this.selectors.close);
			this.newsletterAcceptBtn = this.querySelector(this.selectors.newsletterAcceptBtn);
			this.customAcceptBtn = this.querySelector(this.selectors.customAcceptBtn);
			this.emailInput = this.querySelector(this.selectors.emailInput);

			this.init();
		}

		init() {
			setTimeout(() => {
				this.showModal(this.ref);
			}, this.showAfter);

			this.close?.addEventListener('click', () => {
				this.closeModal(this.ref);
			});

			this.customAcceptBtn?.addEventListener('click', () => {
				this.closeModal(this.ref);
			});

			this.newsletterAcceptBtn?.addEventListener('click', (event) => {
				if (this.emailInput?.checkValidity()) {
					this.closeModal(this.ref);
					setTimeout(() => {
						event.target.closest('form').submit();
					}, 1000);
				}
			});
		}

		showModal(ref) {
			let modalsStorage = JSON.parse(localStorage.getItem('modals'));

			if (!modalsStorage) {
				modalsStorage = [];
			}

			if (!modalsStorage.includes(ref)) {
				this.classList.add('visible');
			}
		}

		closeModal(ref) {
			let modalsStorage = JSON.parse(localStorage.getItem('modals'));

			if (!modalsStorage) {
				modalsStorage = [];
			}

			if (!modalsStorage.includes(ref)) {
				modalsStorage.push(ref);
				localStorage.setItem('modals', JSON.stringify(modalsStorage));
				this.classList.remove('visible');
			}
		}
	}

	customElements.define('modals-component', ModalsComponent);
}
